import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import { TextareaField } from "../ui/TextareaField";
import type { TextareaHTMLAttributes } from "react";

interface FormTextareaFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    "name" | "value" | "onChange" | "onBlur"
  > {
  name: TName;
  label?: string;
  optional?: boolean;
}

export function FormTextareaField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  label,
  optional,
  ...textareaProps
}: FormTextareaFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, onBlur, errorMessage, disabled }) => (
        <TextareaField
          {...textareaProps}
          name={name}
          label={label}
          optional={optional}
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={textareaProps.disabled || disabled}
          errorMessage={errorMessage}
        />
      )}
    />
  );
}
